export { CartageUpdateModule } from './cartage-update.module';
export { CartageUpdateService } from './cartage-update.service';

export * from './cartage-update';
